var _g, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTransactionsList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(4 4)",
    id: "g12"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#BCC6DA",
    fillRule: "nonzero",
    id: "g4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.5 64.672v12.606h-49V64.672zM77.5 41.561v12.606h-49V41.561zM77.5 19.5v12.606h-49V19.5z",
    id: "path2"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 71.5,
    r: 5.5,
    fill: "#BCC6DA",
    fillRule: "nonzero",
    id: "circle6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 48.5,
    r: 5.5,
    fill: "#BCC6DA",
    fillRule: "nonzero",
    id: "circle8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 19.5,-2.001 c 11.888,0 21.501,9.613 21.501,21.501 0,11.888 -9.613,21.501 -21.501,21.501 C 7.612,41.001 -2.001,31.388 -2.001,19.5 -2.001,7.612 7.612,-2.001 19.5,-2.001 Z",
    id: "path10",
    style: {
      fill: "#FF7A00",
      stroke: "#ffffff",
      strokeWidth: 4.00299978
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 29.443143,14.738431 17.708725,26.950634 a 0.67212716,0.68812597 0 0 1 -0.513231,0.221241 c -0.220866,0 -0.440141,-0.0732 -0.513233,-0.221241 l -5.72182,-6.18012 -0.147773,-0.146409 a 0.7690533,0.78735928 0 0 1 -0.217687,-0.515689 c 0,-0.146409 0.07309,-0.367651 0.219276,-0.51406 l 1.028053,-1.029749 a 0.7182068,0.73530246 0 0 1 1.026464,0 l 0.07309,0.0732 4.032762,4.340236 c 0.147772,0.146409 0.367048,0.146409 0.513232,0 l 9.827673,-10.225907 h 0.07309 a 0.7182068,0.73530246 0 0 1 1.026464,0 l 1.028052,1.029749 c 0.292368,0.221242 0.292368,0.662098 0,0.956544 z",
    id: "path2-9",
    style: {
      fill: "#fbffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      strokeWidth: 1.60775304
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTransactionsList);
export default __webpack_public_path__ + "static/media/icon-transactions-list.786d8c9c3d03a7f145d3e3e3e8adeba5.svg";
export { ForwardRef as ReactComponent };